/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimTask } from './ClaimTask';
import {
    ClaimTaskFromJSON,
    ClaimTaskFromJSONTyped,
    ClaimTaskToJSON,
    ClaimTaskToJSONTyped,
} from './ClaimTask';

/**
 * Paginated list of tasks across claims
 * @export
 * @interface GlobalTaskListResponse
 */
export interface GlobalTaskListResponse {
    /**
     * 
     * @type {Array<ClaimTask>}
     * @memberof GlobalTaskListResponse
     */
    items: Array<ClaimTask>;
    /**
     * Whether there are more results available
     * @type {boolean}
     * @memberof GlobalTaskListResponse
     */
    hasMore: boolean;
    /**
     * Current page number
     * @type {number}
     * @memberof GlobalTaskListResponse
     */
    page: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GlobalTaskListResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the GlobalTaskListResponse interface.
 */
export function instanceOfGlobalTaskListResponse(value: object): value is GlobalTaskListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function GlobalTaskListResponseFromJSON(json: any): GlobalTaskListResponse {
    return GlobalTaskListResponseFromJSONTyped(json, false);
}

export function GlobalTaskListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalTaskListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClaimTaskFromJSON)),
        'hasMore': json['hasMore'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function GlobalTaskListResponseToJSON(json: any): GlobalTaskListResponse {
    return GlobalTaskListResponseToJSONTyped(json, false);
}

export function GlobalTaskListResponseToJSONTyped(value?: GlobalTaskListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ClaimTaskToJSON)),
        'hasMore': value['hasMore'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

